module.exports = __webpack_public_path__ + "img/bannerText.c7496688.png";